module.exports = __webpack_public_path__ + "static/Lachlan-Young-b3f92934d812ba2df3976bc1308d52cc.png";